/** "newbie@example.com" -> "ne••••@example.com" (always shows the domain). */
export function maskEmailAddress(email: string | undefined | null): string {
  if (!email) return '••••••';
  const at = email.lastIndexOf('@');
  if (at < 1) return '••••••';
  const name = email.slice(0, at);
  const domain = email.slice(at + 1);
  const visible = name.length <= 2 ? name.slice(0, 1) : name.slice(0, 2);
  const hidden = Math.max(3, Math.min(6, name.length - visible.length));
  return `${visible}${'•'.repeat(hidden)}@${domain}`;
}
